import React from 'react';

import config from './Config'

import appstore from './Assets/appstore.png'
import googleplay from './Assets/googleplay.png'

import './Download.css';

const Download = () => {
    return (
        <section id="download" className="download">
            <h2 className="downloadcta_title">Get {config.brandname} Now</h2>
            <p className="downloadcta_subtitle">
                Download the {config.brandname} and book trusted professionals in just a few taps.
            </p>

            <div className="download_buttons">
                <a href="#" className="download_button">
                    <img src={appstore} alt="Download on App Store" className="download_icon" />
                </a>

                <a href={config.playstorelink} className="download_button">
                    <img src={googleplay} alt="Get it on Google Play" className="download_icon" />
                </a>
            </div>
        </section>
    );
};

export default Download;